import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';

// Firebase configuration
// Get these from Firebase Console > Project Settings > General
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Check if Firebase is configured
const isFirebaseConfigured = Object.values(firebaseConfig).every(value => value);

let app = null;
let auth = null;

if (isFirebaseConfigured) {
  // Initialize Firebase
  app = initializeApp(firebaseConfig);
  
  // Initialize Firebase Authentication
  auth = getAuth(app);
  
  // Set persistence to SESSION only (clears when browser/tab closes)
  // This prevents Firebase from persisting auth state across browser sessions
  setPersistence(auth, browserSessionPersistence)
    .then(() => {
      console.log('✅ Firebase initialized with SESSION persistence (clears on browser close)');
    })
    .catch((error) => {
      console.warn('⚠️  Firebase persistence setting failed:', error.message);
      console.log('✅ Firebase initialized with default persistence');
    });
} else {
  console.warn('⚠️  Firebase not configured. Add Firebase credentials to .env file');
}

export { auth, app };
export default auth;
